import BreadCrumbs from "components/widgets/bread-crumbs";
import SideNav, { ISideNavRoutes } from "./side-nav";
import TopNav from "./top-nav";
import { BiHomeSmile } from "react-icons/bi";
import { RiUser3Line, RiBankLine } from "react-icons/ri";
import { CgDialpad } from "react-icons/cg";
import { FiPackage, FiUsers } from "react-icons/fi";

function AdminLayout({ children }: { children: JSX.Element }) {
  const routes: ISideNavRoutes[] = [
    {
      display: "Admin",
      path: "/admin",
      icon: <BiHomeSmile />,
      exact: true,
    },
    {
      display: "Numbers",
      path: "/admin/numbers",
      icon: <CgDialpad />,
      exact: true,
    },

    {
      display: "Packages",
      path: "/admin/packages",
      icon: <FiPackage />,
      exact: true,
    },
    {
      display: "Users",
      path: "/admin/users",
      icon: <FiUsers />,
      exact: true,
    },
    {
      display: "Payments",
      path: "/admin/payments",
      icon: <RiBankLine />,
      exact: true,
    },
    {
      display: "Profile",
      path: "/admin/profile",
      icon: <RiUser3Line />,
      exact: true,
    },
  ];

  return (
    <>
      <TopNav />
      <div className="grid grid-cols-12 h-screen w-screen pt-16">
        <SideNav routes={routes} className="col-span-2 sm:col-span-1 md:col-span-3 lg:col-span-2 " />
        <main className="col-span-10 sm:col-span-11 md:col-span-9 lg:col-span-10 overflow-y-scroll">
          <BreadCrumbs />

          {children}
        </main>
        {/* <RightBar className="hidden xl:flex xl:col-span-2" /> */}
      </div>
    </>
  );
}

export default AdminLayout;
